<ion-grid class="container">
  <ion-row class="form-row">
    <h3 class="header">{{ headerText }}</h3>
    @if (hasHeaderCloseButton) {
      <img
        class="exit"
        [src]="IMAGES.CLOSE"
        alt="close"
        (click)="clickExit()"
      />
    }
  </ion-row>
  @if (showErrorBanner()) {
    <ion-row class="error-row">
      <ion-col size="12">
        <app-modal-error-banner
          [bannerType]="errorBannerType"
          (emitExit)="showErrorBanner.set(false)"
        ></app-modal-error-banner>
      </ion-col>
    </ion-row>
  }
  <ng-content></ng-content>
  @if (showFooter) {
    <ion-row class="footer-row">
      @if (leftButton.type !== BUTTON_TYPE.NONE) {
        <ion-col size="auto">
          @switch (leftButton.type) {
            @case (BUTTON_TYPE.CANCEL_BUTTON) {
              <ion-button
                class="cancel-btn"
                fill="outline"
                (click)="clickLeft()"
              >
                {{ CONSTS.CANCEL }}
              </ion-button>
            }
            @case (BUTTON_TYPE.BACK_BUTTON) {
              <ion-button
                class="cancel-btn"
                fill="outline"
                (click)="clickLeft()"
              >
                {{ CONSTS.BACK }}
              </ion-button>
            }
            @case (BUTTON_TYPE.TEXT_BUTTON) {
              <ion-button
                class="submit-button"
                [ngClass]="{ 'is-disabled': leftButton.disable }"
                [disabled]="leftButton.disable"
                (click)="clickLeft()"
              >
                <span slot="start" class="btn-text">
                  {{ leftButton.text }}
                </span>
              </ion-button>
            }
          }
        </ion-col>
      } @else {
        <ion-col size="6"></ion-col>
      }
      @if (rightButton.type !== BUTTON_TYPE.NONE) {
          @switch (rightButton.type) {
            @case (BUTTON_TYPE.ICON_TEXT_BUTTON) {
              <ion-col size="auto">
              <ion-button
                class="submit-button"
                [ngClass]="{ 'is-disabled': rightButton.disable }"
                [disabled]="rightButton.disable"
                (click)="clickRight()"
              >
                <ion-icon
                  slot="start"
                  class="check-icon"
                  [src]="IMAGES.CHECK_OUTLINE"
                ></ion-icon>
                <span slot="end" class="btn-text">{{ rightButton.text }}</span>
              </ion-button>
              </ion-col>
            }
            @case (BUTTON_TYPE.TEXT_BUTTON) {
              <ion-col size="auto">
              <ion-button
                class="submit-button"
                [ngClass]="{ 'is-disabled': rightButton.disable }"
                [disabled]="rightButton.disable"
                (click)="clickRight()"
              >
                <span slot="start" class="btn-text">{{
                  rightButton.text
                }}</span>
              </ion-button>
              </ion-col>
            }
            @case (BUTTON_TYPE.ICON_BUTTON) {
              
        <ion-col size="auto">
              <ion-button
                class="submit-button"
                [ngClass]="{ 'is-disabled': rightButton.disable }"
                [disabled]="rightButton.disable"
                (click)="clickRight()"
              >
                <ion-icon
                  slot="icon-only"
                  class="check-icon"
                  [src]="IMAGES.CHECK_OUTLINE"
                ></ion-icon>
              </ion-button>
              
        </ion-col>
            }
            @case (BUTTON_TYPE.REPORT_BUTTON) {
              <ion-col size="12" class="report-button-col">
              <ion-button
                class="submit-button submit-reports"
                [ngClass]="{ 'is-disabled': rightButton.disable }"
                [disabled]="rightButton.disable"
                (click)="clickRight()"
              >
                <ion-icon
                  slot="start"
                  class="icon-reports"
                  [src]="IMAGES.DOWNLOAD"
                ></ion-icon>
                {{ CONSTS.REPORTS_BUTTON_TEXT }}
              </ion-button>
              </ion-col>
            }
          }
      } @else {
        <ion-col size="6"></ion-col>
      }
    </ion-row>
  }
</ion-grid>
